import React, { useState } from 'react';
import { Button, EasyModal } from '@ui';
import useTranslation from '@app/hooks/use-translation';
import {
  useDeleteMFCriteriaMutation,
  useGetMFCriteriaBulkQuery,
  useLazyGetMFCriteriaInfoSingleQuery,
} from '@app/store/api/qm-module/qm-manage/qm-manage-monitoring-forms.api';
import { useOutletContext, useParams } from 'react-router-dom';
import { MonitoringFormCriteriaObjectType } from '@app/interfaces/qm-module/qm-manage/qm-monitoring-forms.type';
import { RemovalModal } from '@app/components/removal-modal';
import { useGetProjectMetricsListQuery } from '@app/store/api/metrics.api';

import { useGetChatProjectMetricsListQuery } from '@app/store/api/chat-api/chat-metric.api';

import { MonitoringFormSettingsOutletType } from '../../monitoring-forms-settings.outlet';

import CriteriaFormCreate from './criteria-form-create';
import { CriteriaTable } from './criteria_blocks/criteria-table.block';

const CriteriaTab = () => {
  const { t } = useTranslation('pages.qmManage.monitoring_forms.createMonitoringForm');
  const { monitoringFormData } = useOutletContext<MonitoringFormSettingsOutletType>();
  const [criteriaCreateModal, setCriteriaCreateModal] = useState(false);
  const [editableCriteriaData, setEditableCriteriaData] =
    useState<MonitoringFormCriteriaObjectType>();
  const [deletableCriteriaId, setDeletableCriteriaId] = useState<string>();
  const { id } = useParams();
  // api
  const { data: metricsListVoice } = useGetProjectMetricsListQuery(
    {
      project_id: monitoringFormData?.project.project_id || '',
    },
    { skip: monitoringFormData?.project.project_type !== 'voice' },
  );
  const { data: metricsListChat } = useGetChatProjectMetricsListQuery(
    {
      project_id: monitoringFormData?.project.project_id || '',
    },
    { skip: monitoringFormData?.project.project_type !== 'chats' },
  );
  const metricsList = metricsListChat || metricsListVoice;
  const [deleteCriteria] = useDeleteMFCriteriaMutation();
  const [getSingleCriteriaInfo] = useLazyGetMFCriteriaInfoSingleQuery();
  const { data: criteriaListWithBlocks } = useGetMFCriteriaBulkQuery({ mform_id: id || '' });
  // api

  function criteriaCreateCloseModal() {
    setCriteriaCreateModal(false);
    setEditableCriteriaData(undefined);
  }

  function handleEditCriteria(id: string) {
    getSingleCriteriaInfo({ id })
      .unwrap()
      .then((data) => {
        setEditableCriteriaData(data);
        setCriteriaCreateModal(true);
      });
  }
  function handleDeleteCriteria(id: string) {
    setDeletableCriteriaId(id);
  }
  function aproveCriteriaDelete() {
    if (!deletableCriteriaId) return;
    deleteCriteria({ id: deletableCriteriaId });
  }

  return (
    <>
      <div className="w-full flex items-center justify-end py-4">
        <Button
          onClick={() => setCriteriaCreateModal(true)}
          label={t('criteria_add_button')}
          disabled={monitoringFormData?.status !== 'NEW'}
        />
      </div>
      <CriteriaTable
        handleEditCriteria={handleEditCriteria}
        criteriaListWithBlocks={criteriaListWithBlocks}
        handleDeleteCriteria={handleDeleteCriteria}
      />
      <EasyModal
        withoutFooter
        label={t('criteria_add_button')}
        variant="large"
        show={criteriaCreateModal}
        onClose={criteriaCreateCloseModal}
      >
        {criteriaCreateModal && monitoringFormData && (
          <CriteriaFormCreate
            disable={monitoringFormData?.status !== 'NEW'}
            monitoringFormData={monitoringFormData}
            metricsList={metricsList}
            editableCriteriaData={editableCriteriaData}
            onClose={criteriaCreateCloseModal}
          />
        )}
      </EasyModal>
      <RemovalModal
        onClose={() => setDeletableCriteriaId(undefined)}
        show={!!deletableCriteriaId}
        handleDelete={aproveCriteriaDelete}
        description={t('delete_criteria_description')}
      />
    </>
  );
};

export default CriteriaTab;
